module.exports = __webpack_public_path__ + "static/media/eye.76bd98d6.svg";